import React from 'react';
import { Monitor, Clock, BookOpen, MessageCircle, Send, FileCheck, ThumbsUp } from 'lucide-react';
import { Badge } from '../ui/badge';
import { features } from '../../data/mock';

const iconMap = {
  Monitor: Monitor,
  Clock: Clock,
  BookOpen: BookOpen,
  MessageCircle: MessageCircle
};

const steps = [
  {
    number: '01',
    title: 'Envía tu problema',
    description: 'Comparte tu examen o problema por WhatsApp con foto clara',
    icon: Send
  },
  {
    number: '02',
    title: 'Recibe la solución',
    description: 'Te envío la resolución completa paso a paso en menos de 24h',
    icon: FileCheck
  },
  {
    number: '03',
    title: 'Resuelve tus dudas',
    description: 'Si tienes alguna pregunta, te explico hasta que entiendas',
    icon: ThumbsUp
  }
];

const HowItWorks = () => {
  return (
    <section id="como-funciona" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge variant="outline" className="mb-4 px-4 py-1 text-blue-600 border-blue-200 bg-blue-50">
            Proceso Simple
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            Cómo Funciona la{' '}
            <span className="text-blue-600">Resolución en Línea</span>
          </h2>
          <p className="text-lg text-slate-600">
            Un proceso sencillo y rápido para que obtengas las soluciones que necesitas
          </p>
        </div>

        {/* Steps */}
        <div className="relative mb-20">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-blue-200 to-transparent" />
          
          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-8 shadow-lg shadow-slate-200/50 hover:shadow-xl hover:shadow-blue-500/10 transition-all duration-300 h-full">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-14 h-14 rounded-2xl bg-blue-600 text-white flex items-center justify-center font-bold text-xl shadow-lg shadow-blue-600/30">
                      {step.number}
                    </div>
                    <div className="p-3 rounded-xl bg-blue-50 text-blue-600">
                      <step.icon className="w-6 h-6" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800 mb-3">{step.title}</h3>
                  <p className="text-slate-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group p-6 bg-white rounded-2xl border border-slate-200 hover:border-blue-300 hover:shadow-lg hover:shadow-blue-500/10 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors">
                  <IconComponent className="w-6 h-6" />
                </div>
                <h4 className="text-lg font-semibold text-slate-800 mb-2">{feature.title}</h4>
                <p className="text-slate-600 text-sm">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
